import dayjs from 'dayjs'

import { RunsheetShift, RunsheetShiftStatus } from '@/entities/schedules/models/runsheet/RunsheetShift'

export const getRunsheetShiftStatus = (shift: RunsheetShift, timezoneOffset: string | null) => {
  let status: RunsheetShiftStatus = 'notStarted'
  let statusTooltip: string = ''

  if (shift.startedOn && shift.completedOn) {
    status = 'completed'
    statusTooltip = 'Run completed by ' + shift.completedByName + ' at ' + shift.completedOn

    return {
      status,
      statusTooltip,
    }
  }
  
  if (shift.startedOn && !shift.completedOn) {
    status = 'active'
    statusTooltip = 'Run started by ' + shift.startedByName + ' at ' + shift.startedOn

    return {
      status,
      statusTooltip,
    }
  }

  const utcNow = dayjs.utc()
  const utcStartTime = dayjs.utc(
    `${shift.start.plannedArrival} ${timezoneOffset}`,
    'DD/MM/YYYY HH:mm ZZ',
  )

  if (utcStartTime.isAfter(utcNow)) {
    statusTooltip = 'Run scheduled to Start at ' + shift.start.plannedTime
    status = 'notStarted'
  }
  else {
    statusTooltip = 'Run has not started past its Scheduled Time : ' + shift.start.plannedTime
    status = 'late'
  }

  return {
    status,
    statusTooltip,
  }
}